export default __webpack_public_path__ + "static/media/CPCloseIcon.7346984b.svg";